<template>
  <div class="market-key-stats">
    <div class="market-key-stats__title">{{ obj.title }}</div>
    <div class="market-key-stats__content">
      <market-key-stats-element v-for="(elem, index) in items" :key="index" :widget="elem">
      </market-key-stats-element>
    </div>
  </div>
</template>

<script src="./market-key-stats.js"></script>
<style src="./market-key-stats.scss" lang="scss"></style>
